import axios from 'axios'
import urls from '../common/js/urls.js'

export function getQuizData(category_id, pageNum) {
  var user_id = localStorage.getItem("user_id");
  if ($.isEmptyObject(user_id)) {
    user_id = '5587'
  }
  return new Promise(function (resolve, reject) {
    var url = urls.get_quiz_list + "?category_id=" + category_id + "&pageNum=" + pageNum + "&pageSize=20&application_id=1&user_id=" + user_id;
    axios.get(url).then(function (res) {
      resolve(res.data.result)
    }).catch((response) => {
      reject(response);
    })
  });
}

export function getMyQuizData(pageNum) {
  var user_id = localStorage.getItem("user_id");
  return new Promise(function (resolve, reject) {
    var url = urls.get_my_quiz_list + "?pageNum=" + pageNum + "&pageSize=20&application_id=1&userid=" + user_id;
    axios.post(url).then(function (res) {
      resolve(res.data.result)
    }).catch((response) => {
      reject(response);
    })
  });
}

export function getQuizDetail(commentId){
  var user_id = localStorage.getItem("user_id");
  if ($.isEmptyObject(user_id)) {
    user_id = '5587'
  }
  return new Promise(function (resolve, reject) {
    var url = urls.get_quiz_detail + "?commentId=" + commentId + "&application_id=1&userid=" + user_id;
    axios.post(url).then(function (res) {
      resolve(res.data.result)
    }).catch((response) => {
      reject(response);
    })
  });
}

export function getQuizCommentList(commentId){
  var user_id = localStorage.getItem("user_id");
  if ($.isEmptyObject(user_id)) {
    user_id = '5587'
  }
  return new Promise(function (resolve, reject) {
    var url = urls.get_quiz_comment_list + "?commentId=" + commentId + "&application_id=1&supportAudio=0&userid=" + user_id;
    axios.post(url).then(function (res) {
      resolve(res.data.result)
    }).catch((response) => {
      reject(response);
    })
  });
}



// WEBPACK FOOTER //
// ./src/networks/QuizRequestHandler.js